<template>
    <div class="main-wrapper">
        <layouts></layouts>

        <div class="page-wrapper">
            <listmapcontent />
        </div>
    </div>
</template>
